import React from 'react';
import { usePersistedCountryDetails } from 'common/hooks';
import { StyledPageWrapper } from 'common/styles';
import { redirectToOrderFast } from 'common/utils';
import router from 'next/router';

import ServiceConfigs from 'service/config';
import useTranslation from 'next-translate/useTranslation';
import StoreFrontHeader from '../StoreFrontHeader';
import { AccessDenied } from '..';

const AuthPage = ({ children }: { children: React.ReactElement<any, any> }): React.ReactElement<any, any> => {
  const userToken = ServiceConfigs?.getUserToken();
  const { t } = useTranslation('errorPages');
  const [persistedCountryDetails] = usePersistedCountryDetails();

  if (userToken) {
    return children;
  }

  return (
    <StyledPageWrapper>
      <StoreFrontHeader title={t('accessDenied.pageTitle')} />
      <AccessDenied
        onClick={() =>
          redirectToOrderFast({
            path: router.asPath,
            locale: router.locale,
            countryCode: persistedCountryDetails?.code,
          })
        }
      />
    </StyledPageWrapper>
  );
};

export default AuthPage;
